<template>
  <div class="wrapper">
    <!-- data Table -->
    <div v-if="showPage">
      <CRow>
        <CCol col="12" xl="12">
          <CCard class="p-0">
            <CCardHeader
              class="d-flex justify-content-between align-items-center bg-secondary"
            >
              <h5 class="text-light m-0 p-0">محدوده های مجاز</h5>
              <CButton
                color="light"
                @click="
                  addModal = true;
                  modalTitle = 'افزودن محدوده';
                  modalButtonSubmit = 'ثبت';
                  restoreDefult();
                "
                class="mr-1"
              >
                <CIcon name="cil-plus" size="lg" /> افزودن
              </CButton>
            </CCardHeader>
            <CCardBody>
              <div id="app">
                <!-- <link
                  href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"
                  rel="stylesheet"
                  integrity="sha384-wvfXpqpZZVQGK6TAh5PVlGOfQNHSoD2xbE+QkPxCAFlNEevoEH3Sl0sibVcOQVnN"
                  crossorigin="anonymous"
                /> -->
                <main>
                  <data-table
                    v-bind="parametersTable"
                    @actionTriggered="handleAction"
                  />
                </main>
              </div>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </div>

    <!-- create and edit device modal -->
    <CModal
      :title="modalTitle"
      :show.sync="addModal"
      size="xl"
      :close-on-backdrop="false"
    >
      <CAlert color="warning" closeButton :show.sync="alert">
        {{ alertText }}
      </CAlert>
      <CForm class="needs-validation" novalidate>
        <h5 class="text-primary mb-3">اطلاعات محدوده</h5>
        <hr />

        <CRow>
          <CInput
            class="col-sm-12 col-md-6 col-lg-4"
            label="نام"
            required
            v-model="info.name"
            :value="info.name"
          />

          <div class="col-sm-12 col-md-6 col-lg-4 form-group">
            <label class="typo__label">وضعیت آلارم</label>
            <multiselect
              class="needs-validation"
              v-model="info.status"
              :options="StatusList"
              :allow-empty="false"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              placeholder="انتخاب..."
              label="label"
              track-by="value"
              :disabled="disableMultiselect"
            ></multiselect>
          </div>

          <!-- <div class="col-sm-12 col-md-6 col-lg-4 form-group">
            <label class="typo__label">وضعیت آلارم</label>
            <multiselect
              class="needs-validation"
              v-model="info.alarmStatus"
              :options="alarmStatusList"
              :allow-empty="false"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              placeholder="انتخاب..."
              label="label"
              track-by="value"
              :disabled="disableMultiselect"
            ></multiselect>
          </div> -->

          <!-- <CCard class="mb-0 p-0">
            <CButton
              block
              class="text-right shadow-none card-header"
              @click="accordion = accordion === 1 ? false : 1"
            >
              <h4 class="m-0 text-info">محدودیت زمانی</h4>
            </CButton>
            <CCollapse :show="accordion === 1">
              <CCardBody>
                <CButtonGroup class="col-sm-12 col-md-8 col-lg-6 mb-3">
                  <CButton
                    id="saturday"
                    class="weekDaysBtn"
                    value="0"
                    @click="daysOfWeek($event)"
                    >شنبه</CButton
                  >
                  <CButton
                    id="sunday"
                    class="weekDaysBtn"
                    value="0"
                    @click="daysOfWeek($event)"
                    >یکشنبه</CButton
                  >
                  <CButton
                    id="monday"
                    class="weekDaysBtn"
                    value="0"
                    @click="daysOfWeek($event)"
                    >دوشنبه</CButton
                  >
                  <CButton
                    id="tuesday"
                    class="weekDaysBtn"
                    value="0"
                    @click="daysOfWeek($event)"
                    >سه‌شنبه</CButton
                  >
                  <CButton
                    id="wednesday"
                    class="weekDaysBtn"
                    value="0"
                    @click="daysOfWeek($event)"
                    >چهارشنبه</CButton
                  >
                  <CButton
                    id="thursday"
                    class="weekDaysBtn"
                    value="0"
                    @click="daysOfWeek($event)"
                    >پنجشنبه</CButton
                  >
                  <CButton
                    id="friday"
                    class="weekDaysBtn"
                    value="0"
                    @click="daysOfWeek($event)"
                    >جمعه</CButton
                  >
                </CButtonGroup>

                <CRow>
                  <vue-clock-picker
                    class="col-sm-12 col-md-6 col-lg-4"
                    label="از ساعت"
                    v-model="info.fromTime"
                    :value="info.fromTime"
                  >
                  </vue-clock-picker>

                  <vue-clock-picker
                    class="col-sm-12 col-md-6 col-lg-4"
                    label="تا ساعت"
                    v-model="info.toTime"
                    :value="info.toTime"
                  >
                  </vue-clock-picker>
                </CRow>

                <CTextarea
                  label="توضیحات"
                  placeholder="Content..."
                  rows="5"
                  v-model="info.description"
                  :value="info.description"
                />
              </CCardBody>
            </CCollapse>
          </CCard> -->

          <CCard class="mb-0 p-0">
            <CButton
              block
              class="text-right shadow-none card-header"
              @click="
                accordion = accordion === 2 ? false : 2;
                showMap();
              "
            >
              <h4 class="m-0 text-primary">محدودیت مکانی</h4>
            </CButton>
            <CCollapse :show="accordion === 2">
              <CCardBody>
                <l-map
                  style="height: 450px"
                  :zoom="zoom"
                  :center="center"
                  ref="limitMap"
                >
                  <l-draw-toolbar position="topleft"></l-draw-toolbar>
                  <l-control-layers position="topright"></l-control-layers>
                  <l-tile-layer
                    v-for="tileProvider in tileProviders"
                    :key="tileProvider.name"
                    :name="tileProvider.name"
                    :visible="tileProvider.visible"
                    :url="tileProvider.url"
                    :attribution="tileProvider.attribution"
                    layer-type="base"
                  />

                  <l-polygon :lat-lngs="positionArrayEdit" ref="polygon"
                    ><l-popup ref="popup"
                      ><CButton @click="poligonEvent" color="danger" class=""
                        ><CIcon name="cil-trash" /></CButton></l-popup
                  ></l-polygon>
                </l-map>
              </CCardBody>
            </CCollapse>
          </CCard>

          <CTextarea
            class="mt-3"
            label="توضیحات"
            placeholder="Content..."
            rows="5"
            v-model="info.description"
            :value="info.description"
          />
        </CRow>
      </CForm>

      <template #footer>
        <CButton
          v-if="modalButtonSubmit == 'تایید'"
          @click="addModal = false"
          color="success"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />تایید</CButton
        >
        <CButton
          v-if="modalButtonSubmit != 'تایید'"
          @click="addModal = false"
          color="danger"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-ban" />لغو</CButton
        >
        <CButton
          v-if="modalButtonSubmit != 'تایید'"
          @click="submitForm"
          color="success"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />{{ modalButtonSubmit }}</CButton
        >
      </template>

      <!-- <template #footer>
        <CButton
          @click="addModal = false"
          color="danger"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-ban" />لغو</CButton
        >
        <CButton
          @click="submitForm"
          color="success"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />{{ modalButtonSubmit }}</CButton
        >
      </template> -->
    </CModal>

    <!-- assig Car to group modal -->
    <CModal title="تخصیص دستگاه" :show.sync="assignModal" size="xl">
      <CForm class="needs-validation" novalidate>
        <h5 class="text-primary mb-3">
          تخصیص دستگاه به محدودیت
          <span class="text-danger">{{ groupName }}</span>
        </h5>
        <hr />

        <CCard class="mb-0 p-0">
          <CButton
            block
            class="text-right shadow-none card-header"
            @click="showFilter = showFilter === 6 ? false : 6"
          >
            <h5 class="text-primary">فیلتر</h5>
          </CButton>
          <CCollapse :show="showFilter === 6">
            <CCardBody>
              <CRow>
                <v-jstree
                  class="my-2"
                  :data="structureListFillter"
                  show-checkbox
                  allow-batch
                  whole-row
                  noDots
                  allow-empty
                  @item-click="setFillter"
                ></v-jstree>
              </CRow>
              <!-- <CRow>
                      <CButton
                        @click="getAlarms()"
                        class="
                          mt-4
                          mb-3
                          btn-success
                          col-12
                        "
                        ><CIcon
                          name="cil-check-circle"
                          class="text-light align-self-center"
                      /></CButton>
                    </CRow> -->
            </CCardBody>
          </CCollapse>
        </CCard>

        <v-multiselect-listbox
          class="col-sm-12 p-3"
          v-model="selectedList2"
          :options="fillterActive == false ? optionList : optionListFilltered"
          :reduce-display-property="(option) => option.label"
          :reduce-value-property="(option) => option.id"
          search-options-placeholder="جستجو..."
          selected-options-placeholder="جستجو..."
          style="direction: ltr; height: '500'"
        ></v-multiselect-listbox>
      </CForm>

      <template #footer>
        <CButton
          @click="assignModal = false"
          color="danger"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-ban" />لغو</CButton
        >
        <CButton
          @click="assignDevicesToDevicesGroup"
          color="success"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />اعمال</CButton
        >
      </template>
    </CModal>

    <!-- Alert modal -->
    <CModal
      :title="alertModalTitle"
      :color="alertModalColor"
      :show.sync="alertModal"
    >
      {{ alertModalText }}

      <template #footer>
        <CButton
          v-if="alertModalTitle != 'حذف محدودیت'"
          @click="alertModal = false"
          :color="alertModalColor"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />{{ alertModalButtonText }}</CButton
        >
        <CButton
          v-if="alertModalTitle == 'حذف محدودیت'"
          @click="deletedeviceFance"
          :color="alertModalColor"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />{{ alertModalButtonText }}</CButton
        >
      </template>
    </CModal>
  </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="css">
.table-wrapper {
  height: 60vh !important;
}

/* time picker style (start) */
.clock-picker__input {
  border: 1px solid gainsboro;
}
.clock-picker__input--error,
.clock-picker__input--error.clock-picker__input--has-value {
  color: #f44336;
}
.clock-picker__input--error .clock-picker__input,
.clock-picker__input--error.clock-picker__input--has-value
  .clock-picker__input {
  border-color: #f44336;
}
.clock-picker__input--has-value .clock-picker__input {
  border-color: #00e676;
}
.clock-picker__button {
  background: none;
  width: 24px;
  height: 24px;
  display: inline-block;
  border: 0;
  border-radius: 12px;
  line-height: 24px;
  padding: 0;
  margin: 0;
  cursor: pointer;
  color: #757575;
  font-weight: 500;
  font-size: 13px;
}
.clock-picker__button:hover {
  background-color: #f5f5f5;
}
.clock-picker__button:active {
  background-color: #ededed;
}
.clock-picker__button:focus {
  background-color: #e8e8e8;
}
.clock-picker__button--active,
.clock-picker__button--active:active,
.clock-picker__button--active:hover,
.clock-picker__button--active:focus {
  background-color: #a48bd1;
  color: #fff;
}
.clock-picker__button[disabled] {
  opacity: 0.4 !important;
  cursor: default;
}
.clock-picker__button[disabled],
.clock-picker__button[disabled]:active,
.clock-picker__button[disabled]:hover,
.clock-picker__button[disabled]:focus {
  background-color: #f5f5f5;
  color: #757575;
}

.clock-picker__dialog {
  display: none;
}
.clock-picker__dialog--active {
  display: block;
}
.clock-picker__dialog-drop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 200;
}
.clock-picker__dialog-body {
  direction: ltr;
  position: fixed;
  top: 50%;
  left: 50%;
  max-width: 100%;
  max-height: 100%;
  overflow: auto;
  width: 320px;
  margin: -235px -160px;
  background-color: #fff;
  z-index: 201;
  transform: scale(1);
  border-radius: 5px;
  overflow: auto;
}
.clock-picker__dialog-header {
  padding: 1.5rem 1.5rem;
  font-size: 2rem;
  text-align: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.clock-picker__dialog-header span:hover,
.clock-picker__dialog-header span:focus {
  cursor: pointer;
}
.clock-picker__dialog-content {
  position: relative;
  width: 100%;
  height: 280px;
  margin-top: 24px;
  margin-bottom: 24px;
}
.clock-picker__dialog-content .clock-picker__hours,
.clock-picker__dialog-content .clock-picker__minutes {
  position: absolute;
}
.clock-picker__dialog-actions {
  direction: rtl;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: row;
  flex-direction: row;
  border-top: 1px solid #f5f5f5;
  padding: 0.5rem;
}
.clock-picker__dialog-action {
  padding: 0 1rem;
  margin: 0;
  background: transparent;
  border: 0;
  -ms-flex: 1;
  flex: 1;
  font-size: 16px;
  font-weight: 500;
  line-height: 32px;
  display: inline-block;
  cursor: pointer;
}
.clock-picker__dialog-action:hover {
  background-color: #f5f5f5;
}
.clock-picker__dialog-action:focus {
  background-color: #ededed;
}
.clock-picker__dialog-action:active {
  background-color: #e6e6e6;
}
.clock-picker__dialog-action[disabled] {
  background-color: #f5f5f5;
  color: #e6e6e6;
}
.clock-picker__dialog-action[disabled]:hover,
.clock-picker__dialog-action[disabled]:focus,
.clock-picker__dialog-action[disabled]:active {
  cursor: not-allowed;
}
.clock-picker__dialog .scale-enter-active,
.clock-picker__dialog .scale-leave-active,
.clock-picker__dialog .fade-enter-active,
.clock-picker__dialog .fade-leave-active {
  transition: all 0.3s ease;
}
.clock-picker__dialog .scale-enter,
.clock-picker__dialog .scale-leave-active {
  opacity: 0;
  transform: scale(0);
}
.clock-picker__dialog .fade-enter,
.clock-picker__dialog .fade-leave-active {
  opacity: 0;
}

.clock-picker__hours {
  display: flex;
  justify-content: center;
  position: relative;
  width: 100%;
  height: 280px;
}

.clock-picker__minutes {
  display: flex;
  justify-content: center;
  position: relative;
  width: 100%;
  height: 280px;
}

/* add by alireza */
.clock-picker__input {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 0.25rem;
  -webkit-transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
}

.clock-picker__dialog-action[type="button"] {
  color: #39f !important;
}
.clock-picker__dialog-header {
  background-color: #39f !important;
}
/* time picker style (end) */

.msl-search-list-input {
  direction: rtl;
}
</style>

<script>
import axios from "axios";
import { Values } from "../../commonValues";
import $ from "jquery";
import VueClockPicker from "@pencilpix/vue2-clock-picker";
import Multiselect from "vue-multiselect";
import vMultiselectListbox from "vue-multiselect-listbox";

import {
  LMap,
  LTileLayer,
  LControlLayers,
  LPolygon,
  LPopup,
} from "vue2-leaflet";
import LDrawToolbar from "vue2-leaflet-draw-toolbar";
import VJstree from "vue-jstree-master"; //rtl

export default {
  name: "Modals",

  components: {
    VueClockPicker,
    LMap,
    LTileLayer,
    LControlLayers,
    LDrawToolbar,
    LPolygon,
    LPopup,
    Multiselect,
    vMultiselectListbox,
    VJstree,
  },

  data() {
    return {
      selectedList2: [],
      fillterActive: false,
      structureListFillter: [],
      showFilter: 0,
      optionListFilltered: [],
      selectedListFilltered: [],

      // this part is for main modal (start)
      addModal: false,
      permissions: [],
      modalTitle: "",
      modalButtonSubmit: "",
      // this part is for main modal (end)

      // this part is for alert modal (start)
      alertModal: false,
      alertModalTitle: "",
      alertModalText: "",
      alertModalButtonText: "",
      alertModalColor: "",
      // this part is for alert modal (end)

      // this id use when deleting a row
      devicesFanceId: "",

      assignModal: false,
      optionList: [],
      selectedList: [],
      groupName: "",

      info: {
        id: "",
        name: "",
        saturday: false,
        sunday: false,
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        fromTime: "",
        toTime: "",
        status: { label: "", value: "" },
        positionArray: "",
        description: "",
        //alarmStatus: {},
      },

      StatusList: [],
      disableMultiselect: false,

      // alarmStatusList: [
      //   { label: "فعال", value: "1" },
      //   { label: "غیرفعال", value: "0" },
      // ],

      // this part is for collaps (start)
      collapse: false,
      cardCollapse: true,
      innerCollapse: false,
      accordion: 0,
      text: `
        Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
        richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor
        brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
        tempor, sunt aliqua put a bird on it squid single-origin coffee nulla
        assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore
        wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher
        vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic
        synth nesciunt you probably haven't heard of them accusamus labore VHS.
      `,
      // this part is for collaps (end)

      // this part is for map (start)
      zoom: 13,
      center: [36.672291, 48.49009],
      // center: [51.509, -0.08],
      tileProviders: Values.tileProviders,
      polygonStatus: false,
      polygons: Object,
      polygonsValue: false,
      mapOfLimits: Object,
      positionArrayEdit: [],
      is_popup_show: true,
      // this part is for map (end)

      alert: false,
      alertText: "",
      showPage: true,
    };
  },

  computed: {
    parametersTable() {
      return {
        data: this.permissions,
        actionMode: "single",
        columns: [
          {
            key: "rowNumber",
            title: "ردیف",
            sortable: false,
          },
          {
            key: "name",
            title: "نام",
          },
          {
            key: "activeName",
            title: "وضعیت",
          },
          // {
          //   key: "dayOfWeeks",
          //   title: "روزهای هفته",
          // },
          // {
          //   key: "fromTime",
          //   title: "از ساعت",
          // },
          // {
          //   key: "toTime",
          //   title: "تا ساعت",
          // },
          {
            key: "description",
            title: "توضیحات",
          },
        ],
        actions: ["view", "edit", "delete", "assignCar"],
      };
    },
  },

  mounted() {
    this.refreshTable();

    // get status list value from server
    axios
      .get(Values.serverIp + "Constant/GetActiveSelectList")
      .then((response) => {
        this.StatusList = response.data;
      });

    this.GetOrganizationalStructureTree();

    axios.get(Values.serverIp + "Dashboard/GetMapLayers").then((response) => {
      if (response.status == 200) {
        //console.log(response.status);
        this.tileProviders = response.data.layers;
      }
    });
  },

  methods: {
    //********************************************************************* get organiztion tree */
    GetOrganizationalStructureTree() {
      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(
          Values.serverIp +
            "OrganizationalStructure/GetOrganizationalStructureTree",
          JSON.stringify(""),
          config
        )
        .then((response) => {
          if (response.status == 200) {
            //console.log(response.data);
            //this.structureList = response.data;
            this.structureListFillter = response.data;
          } else {
            // modal unsuccessful edit change
            (this.alertModal = true),
              (this.alertModalTitle = "خطایی رخ داده"),
              (this.alertModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید."),
              (this.alertModalColor = "danger"),
              (this.alertModalButtonText = "تایید");
          }
        })
        .catch((response) => {
          if (response.status != 200) {
            // modal unsuccessful edit change
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText =
              "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
            (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          }
        });
    },
    //********************************************************************* refresh datatable */
    refreshTable() {
      axios
        .get(Values.serverIp + "DeviceFance/DeviceFances")
        .then((response) => {
          this.permissions = response.data.data;
        })
        .catch((response) => {
          //console.log(response.response);
          //console.log("in catch");
          if (response.response.status == 403) {
            // modal unsuccessful edit change
            (this.alertModal = true),
              (this.showPage = false),
              (this.alertModalTitle = "عدم مجوز"),
              (this.alertModalText =
                "شما دارای مجوز دسترسی به این قسمت نمی باشید."),
              (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          } else if (response.response.status == 401) {
            //token has expired
            // modal unsuccessful edit change
            localStorage.removeItem("token");
            localStorage.removeItem("username");
            delete axios.defaults.headers.common["Authorization"];
          }
        });
    },

    //********************************************************************* datatable edit action */
    viewAction(data) {
      // disable alet
      this.alert = false;
      this.polygonStatus = true;
      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(
          Values.serverIp + "DeviceFance/GetDeviceFance",
          JSON.stringify(data.devicesFanceId),
          config
        )
        .then((response) => {
          if (response.status == 200) {
            this.addModal = true;
            this.modalTitle = "ویرایش محدودیت";
            this.modalButtonSubmit = "تایید";

            // clear all red borders
            $(".form-control").removeAttr("style");

            this.info.id = response.data.devicesFanceId;
            this.info.name = response.data.name;
            this.info.saturday = response.data.saturday;
            this.info.sunday = response.data.sunday;
            this.info.monday = response.data.monday;
            this.info.tuesday = response.data.tuesday;
            this.info.wednesday = response.data.wednesday;
            this.info.thursday = response.data.thursday;
            this.info.friday = response.data.friday;
            this.info.fromTime = response.data.fromTime;
            this.info.toTime = response.data.toTime;
            this.setLimitStatusValue(response.data.statusId);
            this.info.positionArray = response.data.positionArray;
            if (response.data.positionArray.length != 0) {
              $(".leaflet-draw-toolbar").hide();
              this.positionArrayEdit = JSON.parse(response.data.positionArray);
              this.center = this.positionArrayEdit[0][0];
            } else {
              this.positionArrayEdit = [];
              $(".leaflet-draw-toolbar").show();
            }
            this.info.description = response.data.description;

            if (response.data.saturday == true) {
              $("#saturday").addClass("text-info");
              $("#saturday").attr("value", "1");
            } else if (response.data.saturday == false) {
              $("#saturday").removeClass("text-info");
              $("#saturday").attr("value", "0");
            }
            if (response.data.sunday == true) {
              $("#sunday").addClass("text-info");
              $("#sunday").attr("value", "1");
            } else if (response.data.sunday == false) {
              $("#sunday").removeClass("text-info");
              $("#sunday").attr("value", "0");
            }
            if (response.data.monday == true) {
              $("#monday").addClass("text-info");
              $("#monday").attr("value", "1");
            } else if (response.data.monday == false) {
              $("#monday").removeClass("text-info");
              $("#monday").attr("value", "0");
            }
            if (response.data.tuesday == true) {
              $("#tuesday").addClass("text-info");
              $("#tuesday").attr("value", "1");
            } else if (response.data.tuesday == false) {
              $("#tuesday").removeClass("text-info");
              $("#tuesday").attr("value", "0");
            }
            if (response.data.wednesday == true) {
              $("#wednesday").addClass("text-info");
              $("#wednesday").attr("value", "1");
            } else if (response.data.wednesday == false) {
              $("#wednesday").removeClass("text-info");
              $("#wednesday").attr("value", "0");
            }
            if (response.data.thursday == true) {
              $("#thursday").addClass("text-info");
              $("#thursday").attr("value", "1");
            } else if (response.data.thursday == false) {
              $("#thursday").removeClass("text-info");
              $("#thursday").attr("value", "0");
            }
            if (response.data.friday == true) {
              $("#friday").addClass("text-info");
              $("#friday").attr("value", "1");
            } else if (response.data.friday == false) {
              $("#friday").removeClass("text-info");
              $("#friday").attr("value", "0");
            }

            // make all part to disabled
            $(
              ".form-check, .form-control-file, .form-control, .clock-picker__input, .weekDaysBtn"
            ).attr("disabled", true);
            this.disableMultiselect = true;
          } else {
            // modal unsuccessful edit change
            (this.alertModal = true),
              (this.alertModalTitle = "خطایی رخ داده"),
              (this.alertModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید."),
              (this.alertModalColor = "danger"),
              (this.alertModalButtonText = "تایید");
          }
        })
        .catch((response) => {
          if (response.status != 200) {
            // modal unsuccessful edit change
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText =
              "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
            (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          }
        });
    },

    //********************************************************************* datatable edit action */
    editAction(data) {
      // disable alet
      this.alert = false;
      this.polygonStatus = true;
      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(
          Values.serverIp + "DeviceFance/GetDeviceFance",
          JSON.stringify(data.devicesFanceId),
          config
        )
        .then((response) => {
          if (response.status == 200) {
            this.addModal = true;
            this.modalTitle = "ویرایش محدودیت";
            this.modalButtonSubmit = "اعمال";

            // clear all red borders
            $(".form-control").removeAttr("style");

            // make all part to enabled
            $(
              ".form-check, .form-control-file, .form-control, .clock-picker__input, .weekDaysBtn"
            ).attr("disabled", false);
            this.disableMultiselect = false;

            this.info.id = response.data.devicesFanceId;
            this.info.name = response.data.name;
            this.info.saturday = response.data.saturday;
            this.info.sunday = response.data.sunday;
            this.info.monday = response.data.monday;
            this.info.tuesday = response.data.tuesday;
            this.info.wednesday = response.data.wednesday;
            this.info.thursday = response.data.thursday;
            this.info.friday = response.data.friday;
            this.info.fromTime = response.data.fromTime;
            this.info.toTime = response.data.toTime;
            this.setLimitStatusValue(response.data.statusId);
            this.info.positionArray = response.data.positionArray;
            if (response.data.positionArray.length != 0) {
              $(".leaflet-draw-toolbar").hide();
              this.positionArrayEdit = JSON.parse(response.data.positionArray);
              this.center = this.positionArrayEdit[0][0];
            } else {
              this.positionArrayEdit = [];
              $(".leaflet-draw-toolbar").show();
            }
            this.info.description = response.data.description;

            if (response.data.saturday == true) {
              $("#saturday").addClass("text-info");
              $("#saturday").attr("value", "1");
            } else if (response.data.saturday == false) {
              $("#saturday").removeClass("text-info");
              $("#saturday").attr("value", "0");
            }
            if (response.data.sunday == true) {
              $("#sunday").addClass("text-info");
              $("#sunday").attr("value", "1");
            } else if (response.data.sunday == false) {
              $("#sunday").removeClass("text-info");
              $("#sunday").attr("value", "0");
            }
            if (response.data.monday == true) {
              $("#monday").addClass("text-info");
              $("#monday").attr("value", "1");
            } else if (response.data.monday == false) {
              $("#monday").removeClass("text-info");
              $("#monday").attr("value", "0");
            }
            if (response.data.tuesday == true) {
              $("#tuesday").addClass("text-info");
              $("#tuesday").attr("value", "1");
            } else if (response.data.tuesday == false) {
              $("#tuesday").removeClass("text-info");
              $("#tuesday").attr("value", "0");
            }
            if (response.data.wednesday == true) {
              $("#wednesday").addClass("text-info");
              $("#wednesday").attr("value", "1");
            } else if (response.data.wednesday == false) {
              $("#wednesday").removeClass("text-info");
              $("#wednesday").attr("value", "0");
            }
            if (response.data.thursday == true) {
              $("#thursday").addClass("text-info");
              $("#thursday").attr("value", "1");
            } else if (response.data.thursday == false) {
              $("#thursday").removeClass("text-info");
              $("#thursday").attr("value", "0");
            }
            if (response.data.friday == true) {
              $("#friday").addClass("text-info");
              $("#friday").attr("value", "1");
            } else if (response.data.friday == false) {
              $("#friday").removeClass("text-info");
              $("#friday").attr("value", "0");
            }
          } else {
            // modal unsuccessful edit change
            (this.alertModal = true),
              (this.alertModalTitle = "خطایی رخ داده"),
              (this.alertModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید."),
              (this.alertModalColor = "danger"),
              (this.alertModalButtonText = "تایید");
          }
        })
        .catch((response) => {
          if (response.status != 200) {
            // modal unsuccessful edit change
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText =
              "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
            (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          }
        });
    },

    //********************************************************************* datatable delete action */
    deleteAction(data) {
      (this.alertModal = true),
        (this.alertModalTitle = "حذف محدودیت"),
        (this.alertModalText =
          "آیا از حذف محدودیت " + data.name + " مطمئن هستید؟"),
        (this.alertModalColor = "warning"),
        (this.alertModalButtonText = "بله"),
        (this.devicesFanceId = data.devicesFanceId);
    },

    //********************************************************************* datatable assign action */
    assignAction(data) {
      //console.log(data);
      this.assignModal = true;
      this.groupName = data.name;
      this.devicesFanceId = data.devicesFanceId;
      this.getdeviceList();
      this.fillterActive = false;
      this.GetOrganizationalStructureTree();
    },

    //********************************************************************* get device list */
    getdeviceList() {
      axios
        .get(Values.serverIp + "device/GetDualBoxMovingDeviceList")
        .then((response) => {
          this.optionList = response.data;
          this.getdeviceSelectedList();
        });
    },

    //********************************************************************* get user selected List */
    getdeviceSelectedList() {
      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(
          Values.serverIp + "DeviceFance/GetDualBoxSelectedDeviceFances",
          JSON.stringify(this.devicesFanceId),
          config
        )
        .then((response) => {
          if (response.status == 200) {
            this.selectedList = response.data;
            this.selectedList2 = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //********************************************************************* assign Users To Group */
    assignDevicesToDevicesGroup() {
      axios
        .post(Values.serverIp + "DeviceFance/AssignDevicesToFance", {
          devicesFanceId: this.devicesFanceId,
          devicesId: this.selectedList2,
        })
        .then((response) => {
          if (response.status == 200 && response.data == "0") {
            this.assignModal = false;

            // modal successfuly
            this.alertModal = true;
            this.alertModalTitle = "تغییرات";
            this.alertModalText = "تغییرات با موفقیت انجام شد.";
            this.alertModalColor = "success";
            this.alertModalButtonText = "تایید";
            this.refreshTable();
          } else {
            // modal unsuccessful
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            if (response.data == "1") {
              this.alertModalText =
                "محدودیت وجود ندارد یا خطایی در سیستم رخ داده است.";
            } else {
              this.alertModalText = "خطایی در انجام کار رخ داده است.";
            }
            this.alertModalColor = "warning";
            this.alertModalButtonText = "تایید";
          }
        })
        .catch((error) => {
          console.log(error);
          // modal unsuccessful
          this.alertModal = true;
          this.alertModalTitle = "خطایی رخ داده";
          this.alertModalText = "در ثبت اطلاعات خطایی رخ داده است.";
          this.alertModalColor = "warning";
          this.alertModalButtonText = "تایید";
        });
    },

    //********************************************************************* dataTable actions */
    handleAction(actionName, data) {
      if (actionName == "view") {
        this.viewAction(data);
      } else if (actionName == "edit") {
        this.editAction(data);
      } else if (actionName == "delete") {
        this.deleteAction(data);
      } else if (actionName == "assignCar") {
        this.assignAction(data);
      }
    },

    //******************************************************************** edit and create device */
    submitForm() {
      // console.log(this.info);

      $(
        ".form-check, .form-control-file, .form-control, .clock-picker__input, .weekDaysBtn"
      ).attr("disabled", false);
      this.disableMultiselect = false;

      $(".form-check, .form-control-file, .form-control").attr(
        "disabled",
        false
      );

      // clear all red borders
      $(".form-control").removeAttr("style");

      var forms = document.querySelectorAll(".needs-validation");
      let formValid = true;

      for (var i = 0; i < forms[0].length; i++) {
        if (
          forms[0][i].type == "text" &&
          forms[0][i].required &&
          forms[0][i].value.length == 0
        ) {
          document.getElementById(forms[0][i].id).style.borderColor = "red";
          formValid = false;
        } else if (
          forms[0][i].type == "number" &&
          forms[0][i].required &&
          forms[0][i].value == ""
        ) {
          document.getElementById(forms[0][i].id).style.borderColor = "red";
          formValid = false;
        } else if (
          forms[0][i].type == "select-one" &&
          forms[0][i].required &&
          forms[0][i].value == ""
        ) {
          document.getElementById(forms[0][i].id).style.borderColor = "red";
          formValid = false;
        }
      }

      let api = "";
      if (this.modalButtonSubmit == "اعمال") api = "EditDeviceFance";
      else {
        api = "CreateDeviceFance";
        this.info.id = "";
      }

      if (formValid == true) {
        // console.log(this.info);

        if (this.info.positionArray.length > 0) {
          axios
            .post(Values.serverIp + "DeviceFance/" + api, {
              devicesFanceId: this.info.id,
              name: this.info.name,
              statusId: JSON.parse(this.info.status.value),
              positionArray: this.info.positionArray,
              description: this.info.description,
              positionArrayEdit: "",
            })
            .then((response) => {
              if (response.status == 200 && response.data == "0") {
                this.addModal = false;

                // modal successfuly
                (this.alertModal = true),
                  (this.alertModalTitle = "تغییرات"),
                  (this.alertModalText = "تغییرات با موفقیت انجام شد."),
                  (this.alertModalColor = "success"),
                  (this.alertModalButtonText = "تایید"),
                  this.refreshTable();
              } else {
                // modal unsuccessful edit change
                this.alertModal = true;
                this.alertModalTitle = "خطایی رخ داده";
                if (response.data == "1") {
                  this.alertModalText = "خطا در ثبت اطلاعات رخ داده است.";
                } else if (response.data == "2") {
                  this.alertModalText = "اطلاعات به درستی وارد نشده است.";
                }
                this.alertModalColor = "warning";
                this.alertModalButtonText = "تایید";
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          this.alertModal = true;
          this.alertModalTitle = "هشدار";
          this.alertModalText = "محدودیت مکانی نمی تواند خالی باشد.";
          this.alertModalColor = "warning";
          this.alertModalButtonText = "تایید";
        }
      } else {
        // this.alert = true;
        // this.alertText = "لطفا تمامی موارد الزامی را وارد نمایید.";
        (this.alertModal = true),
          (this.alertModalTitle = "هشدار"),
          (this.alertModalText = "لطفا تمامی موارد الزامی را وارد نمایید."),
          (this.alertModalColor = "warning"),
          (this.alertModalButtonText = "تایید");
      }
    },

    //******************************************************************** delete device */
    deletedeviceFance() {
      this.alertModal = false;
      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(
          Values.serverIp + "DeviceFance/DeleteDeviceFance",
          JSON.stringify(this.devicesFanceId),
          config
        )
        .then((response) => {
          if (response.status == 200 && response.data == true) {
            //console.log(response);
            this.alertModal = true;
            this.alertModalTitle = "حذف";
            this.alertModalText = "حذف محدودیت با موفقیت انجام شد";
            this.alertModalColor = "success";
            this.alertModalButtonText = "تایید";
            this.refreshTable();
          } else {
            //console.log("in else"),
            (this.alertModal = true),
              (this.alertModalTitle = "خطایی رخ داده"),
              (this.alertModalText =
                "هنگام حذف اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید."),
              (this.alertModalColor = "danger"),
              (this.alertModalButtonText = "تایید");
          }
        })
        .catch((response) => {
          //console.log("in catch");
          if (response.status != 200) {
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText =
              "هنگام حذف اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
            this.alertModalColor = "danger";
            this.alertModalButtonText = "تایید";
          }
        });
    },

    //******************************************************************** restore all create input defult */
    restoreDefult() {
      // make all part to enabled
      $(
        ".form-check, .form-control-file, .form-control, .clock-picker__input, .weekDaysBtn"
      ).attr("disabled", false);
      this.disableMultiselect = false;

      this.info.id = "";
      this.info.name = "";
      this.info.status = { label: "", value: "" };
      this.info.saturday = false;
      this.info.sunday = false;
      this.info.monday = false;
      this.info.tuesday = false;
      this.info.wednesday = false;
      this.info.thursday = false;
      this.info.friday = false;
      this.info.fromTime = "";
      this.info.toTime = "";
      this.info.positionArray = "";
      this.info.description = "";
      this.positionArrayEdit = [];
      $(".leaflet-draw-toolbar").show();

      $(
        "#saturday,#sunday,#monday,#tuesday,#wednesday,#thursday,#friday"
      ).removeClass("text-info");
      $("#saturday,#sunday,#monday,#tuesday,#wednesday,#thursday,#friday").attr(
        "value",
        "0"
      );

      // clear all red borders
      $(".form-control").removeAttr("style");

      // disable alet
      this.alert = false;

      // clear all polygons of map
      if (this.polygonsValue) {
        this.mapOfLimits.removeLayer(this.polygons);
        $(".leaflet-draw-toolbar").show();
      }

      this.polygonStatus = false;
    },

    //******************************************************************** select days of week */
    daysOfWeek(event) {
      let buttonInfo = event.currentTarget;

      if (buttonInfo.value == "0") {
        // activation part
        $("#" + buttonInfo.id).addClass("text-info");
        $("#" + buttonInfo.id).attr("value", "1");
        switch (buttonInfo.id) {
          case "saturday":
            this.info.saturday = true;
            break;
          case "sunday":
            this.info.sunday = true;
            break;
          case "monday":
            this.info.monday = true;
            break;
          case "tuesday":
            this.info.tuesday = true;
            break;
          case "wednesday":
            this.info.wednesday = true;
            break;
          case "thursday":
            this.info.thursday = true;
            break;
          case "friday":
            this.info.friday = true;
            break;
        }
      } else if (buttonInfo.value == "1") {
        // deactivation part
        $("#" + buttonInfo.id).removeClass("text-info");
        $("#" + buttonInfo.id).attr("value", "0");

        switch (buttonInfo.id) {
          case "saturday":
            this.info.saturday = false;
            break;
          case "sunday":
            this.info.sunday = false;
            break;
          case "monday":
            this.info.monday = false;
            break;
          case "tuesday":
            this.info.tuesday = false;
            break;
          case "wednesday":
            this.info.wednesday = false;
            break;
          case "thursday":
            this.info.thursday = false;
            break;
          case "friday":
            this.info.friday = false;
            break;
        }
      }
    },

    showMap() {
      setTimeout(() => {
        //mapObject is a property that is part of leaflet
        this.$refs.limitMap.mapObject.invalidateSize();
      }, 100);

      // set display of map footer none
      $(".leaflet-control-attribution").hide();

      // select map and gives it latlngs
      this.$nextTick(() => {
        this.mapOfLimits = this.$refs.limitMap.mapObject;
        this.mapOfLimits.on(window.L.Draw.Event.CREATED, (e) => {
          this.positionArrayEdit = [];
          const layer = e.layer;
          this.polygons = layer;
          this.polygonsValue = true;
          this.info.positionArray = JSON.stringify(this.polygons.getLatLngs());
          //console.log(this.polygons.getLatLngs());
        });
      });
    },

    poligonEvent() {
      this.$refs.polygon.mapObject.closePopup();
      this.positionArrayEdit = [];
      this.info.positionArray = "";
      $(".leaflet-draw-toolbar").show();
    },

    //********************************************************************* on edit acttion set device status */
    setLimitStatusValue(data) {
      for (var i = 0; i < this.StatusList.length; i++) {
        if (this.StatusList[i].value == data) {
          this.info.status.label = this.StatusList[i].label;
          this.info.status.value = this.StatusList[i].value;
        }
      }
    },

    //***************************************************************** */
    setFillter(node) {
      // this.selectedParent = node.model.id;
      // console.log(this.selectedParent);

      this.fillterActive = true;

      this.optionListFilltered = this.optionList.filter(function (el) {
        return el.organizationIdTree.includes(node.model.id);
        //el.statusId.includes(tempIds)
      });

      this.selectedListFilltered = [];

      for (let i = 0; i < this.optionListFilltered.length; i++) {
        if (this.selectedList.includes(this.optionListFilltered[i].id))
          this.selectedListFilltered.push(this.optionListFilltered[i].id);
      }

      this.selectedList2 = this.selectedListFilltered;
    },
  },
};
</script>
